<template>
	<div class="w1 aidetail" :class="aiswitch?'showai':''">
	<div  class="Search_wrapper"><!-- Search_wrapper -->
					<el-skeleton :rows="20" :loading="isloading" animated >
						<div class="group2"><!-- group2 -->
							<!-- <div class="group2_L">
							
								<mulu v-if="hasMulu"></mulu>
								
								<toutiao v-if="hasToutiao"></toutiao>
								
								<tuijian v-bind:relatedata="resultRelateData"></tuijian>
						
							</div> -->
							<div class="group2_M"><!-- group2_M -->
							
								<div class="text_wrap"><!-- text_wrap -->
									<div class="text_h1" v-html="htmltitle"></div>
									<div class="text_h2">
										<ul class="date_source">
											<li>来源：<span>{{(sourcecol=='zhengce'||sourcecol=='guihua')?'中经政策法规库':resultDetailData.source}}</span></li>
											<li>发布时间：<span>{{resultDetailData.publishtime?resultDetailData.publishtime.substring(0,10):''}}</span></li>
											<li v-if="(hasPower&&sourcecol!='shushuo'&&resultDetailData.articlecontent!=null&&!hasPDF&&!aiswitch)||(hasPower&&resultDetailData.source&&resultDetailData.source=='中国经济信息网'&&hasPDF&&resultDetailData.articlecontent!=null&&!aiswitch)" @click="openai" style="background: #BD1A2D;box-shadow: 0px 0px 10px 0px #bd6e78;color: #fff;border-radius: 15px;padding: 0 10px;cursor: pointer;">AI阅读总结</li>
										</ul>
										<div class="set">
											<div>【 &nbsp;&nbsp;字体：
												<span id="big" :class="fontSizeClass=='font-size-big'?'active':''"
													@click="changeFontSize(1)">大</span>
												<span id="normal" :class="fontSizeClass=='font-size-medium'?'active':''"
													@click="changeFontSize(2)">中</span>
												<span id="small" :class="fontSizeClass=='font-size-small'?'active':''"
													@click="changeFontSize(3)">小</span>
												】
											</div>
											<ul>
												<li v-if="hasFavorite=='0'" @click="addfavorite"><img src="/images/icon-uncollect.png"
														class="flow active" /><span>收藏</span></li>
												<li v-if="hasFavorite=='1'" @click="removefavorite"><img src="/images/icon-collected.png"
														class="flow" /><span>取消收藏</span></li>
												<li v-if="hasPower&&(hasPDF==false)" @click="downloadWord"><img src="/images/icon-download.png"
														class="fileDown" />
														<span v-if="htmlcontent.indexOf('<img src')>-1">下载此文章</span>
														<span v-else>下载为word格式</span>
												</li>
												<li v-if="hasPower&&(hasPDF==true)" @click="downloadPDF"><img src="/images/icon-download.png"
														class="fileDown" /><span>下载为PDF</span></li>
												<li @click="sharelink"><img src="/images/icon-share.png" class="share" /><span>分享标题和链接</span></li>
											</ul>
										</div>
									</div>
									<div style="position: relative;">
										
									</div>
									<dl v-if="!isToutiao&&resultDetailData.summary&&resultDetailData.summary.indexOf('attachment')<0" class="text_abstr">
										<dt>【内容提要】</dt>
										<dd>
											<p>{{resultDetailData.summary}}</p>
										</dd>
									</dl>
									<!-- <div v-if="resultDetailData.keyword" class="text_smalllabel">
										<a v-for="item in resultDetailData.keyword.split('|')" href="javascript:;" style="pointer-events: none;">{{item}}</a>
									</div> -->
									<div class="splitline1"></div>
									<div v-if="!hasPower" class="text_txt clearfix" style="text-align: center;">
										<p v-if="!hasPDF"  v-html="(htmlcontent?htmlcontent:'')+'......'" :class="fontSizeClass" style="text-align: left;text-indent: 2em;"></p>
										<img src="/images/noauth.png" style="margin: 40px;"/>
										<p>未订购内容每日免费浏览5篇文章，今日次数已达上线。浏览更多内容，请拨打服务线：010-68558322</p>
									</div>
									<div v-else-if="!hasPDF" class="text_txt clearfix" v-html="htmlcontent" :class="fontSizeClass">
									</div>
									<div v-else class="text_txt clearfix">
										<iframe :src="'/pdfjs/web/viewer.html?file='+pdfUrl" style="width: 100%;height: 900px;"></iframe>
									</div>
									<!-- <div v-else class="text_txt clearfix">
										<iframe :src="'/pdfjs/web/viewers.html?file='+pdfUrl" style="width: 100%;height: 900px;"></iframe>
									</div> -->
									
									<guanlian v-if="hasGuanlian" v-bind:relatedata="resultRelateData" v-bind:source="articleid"></guanlian>
									
									<dianping v-if="hasDianping"></dianping>
									
							
								</div><!-- /text_wrap -->
						
							</div><!-- /group2_M -->
							
						</div><!-- /group2 -->
	
						
						
						
						<div class="m_b1" style="margin-bottom: 16px;"></div>
					
					</el-skeleton>
					
					</div><!-- /Search_wrapper -->
					
					<div class="aipanel">
						<el-card class="aicard">
						  <div slot="header" class="">
						    <span style="font-weight: bold;">AI阅读总结</span>
						    <el-button style="float: right;padding: 5px;" icon="el-icon-close" circle @click="aiswitch=false"></el-button>
						  </div>
							<div class="aitabs">
						  <!-- <el-tabs v-model="aitab" class="aitabs">
								<el-tab-pane label="简读" name="简读" class="aisummary">
									<div v-loading="isloadingsum" class="summary_contnet">
										<div v-if="!isloadingsum" class="">
											<p>文章主要内容：</p>
											<p class="abstract_contnet">{{abstract}}</p>
											<p>根据此篇文章生成如下大纲：</p>
										</div>
										<div class="markdown-body" v-html="summarycontent"></div>
									</div>
								</el-tab-pane>
								<el-tab-pane label="对话" name="对话" class="aidialogue"> -->
								<div class="aidialogue">
									<div class="dialogue_contnet">
										<div id="dialogue_history" class="dialogue_history">
											<div class="question_tips">对当前文档有什么需要快速了解的内容可以提出任意问题，问题越详细，回答越准确</div>
											<div class="question_tips_queslist">
												<div v-for="item in defaultList" class="question_tips_queslist_default" @click="clickQuestion(item)">
													{{item}} <i class="el-icon-top-right"></i>
												</div>
											</div>
											<template v-for="(item,index) in dialogueData">
												<div v-if="item.type==0" class="question_ask">{{item.content}}</div>
												<div v-else-if="item.type==1" class="question_answer markdown-body">
													<i class="el-icon-loading" v-if="index==dialogueData.length-1&&isloadingdialogue"></i>
													<span v-html="item.content"></span>
												</div>
											</template>
										</div>
										<div class="question_form">
											<el-input v-model="aiask" placeholder="请输入问题" class="question_input" :disabled="isdisableinput" @keyup.enter.native="askfnc"></el-input>
											<el-button type="primary" icon="el-icon-chat-dot-round" circle class="question_submit" :disabled="isdisableinput||!aiask" @click="askfnc"></el-button>
											<div class="question_announce">内容由AI大模型生成，不能完全保障真实</div>
										</div>
									</div>
								</div>
							</div>
								<!-- </el-tab-pane>
							</el-tabs> -->
						</el-card>
					</div>
					
					</div>
</template>

<script>
	import mulu from '@/components/detail-mulu.vue'
	import toutiao from '@/components/detail-toutiao.vue'
	import tuijian from '@/components/detail-tuijian.vue'
	import dianping from '@/components/detail-dianping.vue'
	import guanlian from '@/components/detail-guanlian.vue'
	import marked from 'marked'
	import md5 from 'js-md5';
	export default {
		data() {
			return {
				hasPower:true,
				isloading:true,
				articleid:"",
				sourceid:'',
				favtype:'',
				resultDetailData: {},
				resultAttData:[],
				resultRelateData: [],
				hasFavorite:'',
				hasMulu:false,
				hasToutiao:false,
				hasDianping:false,
				hasGuanlian:false,
				hasPDF:false,
				pdfUrl:'',
				keyword:'',
				htmltitle:'',
				htmlcontent:'',
				isToutiao:false,
				isFromsearch:false,
				isFromtheme:'',
				sourcecol:'',
				fontSizeClass: 'font-size-medium',
				usercode:'',
				aiswitch:false,
				aitab:'简读',
				defaultList:[
					'请简述文章主要内容',
					'请详细描述文章主旨，500字',
					'请总结文章大纲脉络',
				],
				abstract:'',
				isloadingsum:true,
				markdownTxt:'',
				summarycontent:'',
				aiask:'',
				dialogueData:[],
				sourceList:[],
				isloadingdialogue:true,
				isdisableinput:false,
			}
		},
		components:{
			mulu,
			toutiao,
			tuijian,
			dianping,
			guanlian,
		},
		created:function(){
			this.articleid=this.$route.params.id;
			this.keyword=this.$route.query.key?this.$route.query.key:'';
			this.sourceid=this.$route.query.source?this.$route.query.source:'';
			this.favtype=this.$route.query.favtype?this.$route.query.favtype:'1';
			this.isFromsearch=this.$route.query.s?'1':'';
			this.isFromtheme=this.$route.query.the?'1':'';
			this.sourcecol=this.$route.query.col?this.$route.query.col:'';
			this.isToutiao=this.$route.params.toutiaoflag?true:false;
			this.usercode=md5(this.articleid+Date.now());
			this.getdetailfnc();
			this.getrelatefnc();
		},
		mounted:function(){
			// debugger
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
		},
		computed: {
	
		},
		watch: {
			$route (to, from) {
				if(to.params.id != from.params.id){
					this.articleid =  to.params.id;
					this.keyword=this.$route.query.key?this.$route.query.key:'';
					this.sourceid=this.$route.query.source?this.$route.query.source:'';
					this.getdetailfnc();
					this.getrelatefnc();
				}
			}
		},
		methods: {
			authcheck:function(){
				// this.hasPower=false;
				// if(!this.$cookies.get('userauth')){
				// 	this.hasPower=true;
				// }
				// else{
				// 	if(this.$cookies.get('userauth')=='1921f9e1416473a1d0f15d328e837115'){
				// 		this.hasPower=true;
				// 	}
				// 	if(this.$cookies.get('userauth').length>0){
				// 		this.hasPower=true;
				// 	}
				// }
			},
			getdetailfnc: function() {
				let _this = this;
				_this.resultDetailData = {};
				if(_this.sourceid){
					_this.$track([
						['pagetype','相关推荐'],
						['reqtype','1'],
						['pageid',_this.sourceid],
						['relatedpageid',_this.articleid]
					]);
				}
				this.$http({
						method: 'get',
						url: 'article/getById',
						responseType: 'json',
						params: {
							id: this.articleid,
							userid: this.$cookies.get('userinfo')?this.$cookies.get('userinfo').userAccountID:'',
							searchparm: this.isFromsearch,
							strtype: this.isFromtheme,
							ColAlias:this.sourcecol,
						},
					})
					.then(function(response) {
						// console.log(response);
						// debugger;
						if(response.data.code==40003){
							alert(response.data.msg);
							window.location.href='/';
							return false;
						}
						// else if(response.data.code==40004){
						// 	alert(response.data.msg);
						// 	window.location.href='/';
						// 	return false;
						// }
						
						_this.hasPower=response.data.data.data.isReadArt==0?false:true;
						
						_this.authcheck();
						if(response.data.data.data.article){
							if(_this.hasPower){
								_this.$track([
									['pagetype','文章'],
									['reqtype','1'],
									['pageid',_this.articleid]
								]);
							}
							_this.resultDetailData = response.data.data.data.article;
							_this.resultAttData = response.data.data.data.att;
							document.title=_this.resultDetailData.articletitle+'-中经专网';
							_this.hasFavorite=(_this.$cookies.get('userinfo')&&(_this.resultDetailData.userid==_this.$cookies.get('userinfo').userAccountID))?'1':'0';
							_this.hasPDF=false;
							
							
							///附件替换
							////////////////////////////////////////////////////////////////////////////
							// if(_this.resultDetailData.articlehtmlcontent&&_this.resultDetailData.articlehtmlcontent.indexOf('/attachment')>-1){
							// debugger
							
							if(_this.resultAttData.length>0){
								var preurl=window.location.pathname;
								preurl=preurl.substring(0,preurl.indexOf('detail/')>-1?preurl.indexOf('detail/'):preurl.length);
								preurl=window.location.protocol+'//'+window.location.host+preurl;
								var pdfdownloadurl=(process.env.NODE_ENV === 'development' ? '/proxyapi/' : preurl)+'article/DownLoad?searchparm='+_this.isFromsearch+'&strtype='+_this.isFromtheme+'&ColAlias='+_this.sourcecol+'&articleId=';
								var attdownloadurl=(process.env.NODE_ENV === 'development' ? '/proxyapi/' : preurl)+'article/DownLoadByAttID?searchparm='+_this.isFromsearch+'&strtype='+_this.isFromtheme+'&ColAlias='+_this.sourcecol+'&articleId='+_this.articleid+'&attId=';
								for(var i=0;i<_this.resultAttData.length;i++){
									if(_this.resultAttData[i].filetype=='mp4'){
										_this.resultDetailData.articlehtmlcontent='<video style="width:100%;margin-bottom:30px;" controls controlsList="nodownload"><source src="'+_this.resultAttData[i].url+'" type="video/mp4">您的浏览器不支持播放此视频</video>'+_this.resultDetailData.articlehtmlcontent;
									}
									else{
										if(_this.resultAttData[i].showinpage){
											var attRegExp=new RegExp('&lt;attachment id=&quot;'+_this.resultAttData[i].attid+'&quot;&gt;(.*?)&lt;/attachment&gt;');
											var matchArr=_this.resultDetailData.articlehtmlcontent.match(attRegExp);
											if(matchArr&&matchArr.length>1&&matchArr[1]==''){
												_this.resultDetailData.articlehtmlcontent=_this.resultDetailData.articlehtmlcontent.replace(matchArr[0],'<a href="'+attdownloadurl+_this.resultAttData[i].attid+'" style="color:blue;" id="'+_this.resultAttData[i].attid+'">下载附件</a>');
											}
											else{
												_this.resultDetailData.articlehtmlcontent=_this.resultDetailData.articlehtmlcontent.replace('&lt;attachment id=&quot;'+_this.resultAttData[i].attid+'&quot;&gt;','<a href="'+attdownloadurl+_this.resultAttData[i].attid+'" style="color:blue;" id="'+_this.resultAttData[i].attid+'">');
												_this.resultDetailData.articlehtmlcontent=_this.resultDetailData.articlehtmlcontent.replace('&lt;/attachment&gt;','</a>');
											}
										}
										else{
											_this.hasPDF=true;
											_this.pdfUrl=encodeURIComponent(pdfdownloadurl+_this.articleid);
											break;
										}
									}
									
								}
							}
							// else{
							// 	_this.hasPDF=true;
							// 	_this.pdfUrl=encodeURIComponent(pdfdownloadurl+_this.articleid);
							// }
							// }
							////////////////////////////////////////////////////////
							
							if(_this.keyword){
								var regExp = new RegExp(_this.keyword, 'g');
								_this.htmltitle=_this.resultDetailData.articletitle.replace(regExp,'<span style="color:red;">'+_this.keyword+'</span>');
								_this.htmlcontent=_this.resultDetailData.articlehtmlcontent.replace(regExp,'<span style="color:red;">'+_this.keyword+'</span>');
							}
							else{
								_this.htmltitle=_this.resultDetailData.articletitle;
								_this.htmlcontent=_this.resultDetailData.articlehtmlcontent;
							}
						}
						else{
							_this.$alert('此文章不存在，点击确定回到首页', '错误', {
								confirmButtonText: '确定',
								callback: action => {
									_this.$router.push('/');
								}
							});
						}
						document.body.scrollTop = 0;
						document.documentElement.scrollTop = 0;
						_this.isloading=false;
					})
					.catch(function(error) {
						_this.isloading=false;
						console.log(error);
					});
			},
			getrelatefnc: function() {
				let _this = this;
				_this.resultRelateData = [];
				this.$http({
						method: 'get',
						url: 'SearchInfo/CurArtSearchListInfo',
						responseType: 'json',
						params: {
							id: this.articleid,
						},
					})
					.then(function(response) {
						_this.resultRelateData = response.data.data.data;
						if(_this.resultRelateData.length){
							_this.hasGuanlian=true;
						}
						else{
							_this.hasGuanlian=false;
						}
					})
					.catch(function(error) {
						console.log(error);
					});;
			},
			addfavorite:function(){
				if(this.$cookies.get('userinfo')&&this.$cookies.get('userinfo').userAccountID){
					let _this = this;
					this.$http({
							method: 'post',
							url: 'article/addToFavorites',
							responseType: 'json',
							params: {
								userid: this.$cookies.get('userinfo').userAccountID,
								id:this.articleid,
								articletype:this.favtype
							},
						})
						.then(function(response) {
							if(response.data.success){
								_this.$message({
									message: '收藏成功',
									type: 'success'
								});
								_this.hasFavorite=1;
								_this.$track([
									['pagetype','添加收藏'],
									['pageid',_this.articleid]
								]);
							}
						})
						.catch(function(error) {
							console.log(error);
						});
				}
			},
			removefavorite:function(){
				if(this.$cookies.get('userinfo')&&this.$cookies.get('userinfo').userAccountID){
					let _this = this;
					this.$http({
							method: 'post',
							url: 'article/removeFromFavorites',
							responseType: 'json',
							params: {
								userid: this.$cookies.get('userinfo').userAccountID,
								id:this.articleid
							},
						})
						.then(function(response) {
							if(response.data.success){
								_this.$message({
									message: '已取消收藏',
									type: 'success'
								});
								_this.hasFavorite=0;
								_this.$track([
									['pagetype','删除收藏'],
									['pageid',_this.articleid]
								]);
							}
						})
						.catch(function(error) {
							console.log(error);
						});
				}
			},
			changeFontSize: function(type) {
				if (type == 1) {
					this.fontSizeClass = "font-size-big";
				} else if (type == 3) {
					this.fontSizeClass = "font-size-small";
				} else {
					this.fontSizeClass = "font-size-medium";
				}
			},
			jumppush: function(to) {
				var a = document.createElement('a');
				a.setAttribute('href', to);
				a.setAttribute('style', 'display:none');
				// a.setAttribute('target', '_blank');  
				document.body.appendChild(a);
				a.click();
				a.parentNode.removeChild(a);
			},
			downloadWord: function() {
				this.$message({
					message: '已下载',
					type: 'success'
				});
				this.$track([
					['pagetype', '下载Word'],
					['pageid', this.articleid]
				]);
				this.jumppush((process.env.NODE_ENV === 'development' ? '/proxyapi' : '') +
					'/article/DownLoadWord?id=' + this.articleid);
			},
			downloadPDF: function() {
				this.$message({
					message: '已下载',
					type: 'success'
				});
				this.$track([
					['pagetype', '下载PDF'],
					['pageid', this.articleid]
				]);
				this.jumppush((process.env.NODE_ENV === 'development' ? '/proxyapi' : '') +
					'/article/DownLoad?articleId=' + this.articleid);
			},
			sharelink: function() {
				// debugger
				var temptext = '';
				temptext += '标题：' + this.resultDetailData.articletitle + '\r\n';
				temptext += '链接：' + window.location.href + '\r\n';
				temptext += '来源：中经专网';
				const textarea = document.createElement('textarea'); 
				textarea.value = temptext; 
				document.body.appendChild(textarea);
				textarea.select();
				document.execCommand('Copy');
				document.body.removeChild(textarea);
				this.$track([
					['pagetype', '分享'],
					['pageid', this.articleid]
				]);
				this.$message({
					message: '复制分享链接成功',
					type: 'success'
				});
			},
			
			openai:function(){
				this.aiswitch=true;
				// if(!this.summarycontent){
				// 	// this.getsummaryfnc();
				// 	this.getabstractfnc();
				// }
				// if(this.dialogueData.length<1){
				// 	this.defaultQuestion();
				// }
			},
			getabstractfnc: function() {
				let _this = this;
				_this.isloadingsum=true;
				_this.abstract = '';
				this.$httpai({
						method: 'get',
						url: 'GetAbstract',
						responseType: 'json',
						params: {
							titleId: this.articleid,
						},
					})
					.then(function(response) {
						// debugger
						if(response.data){
							
							_this.abstract = response.data;
							
							_this.getsummaryfnc();
						}
						// _this.isloadingsum=false;
					})
					.catch(function(error) {
						_this.isloadingsum=false;
						console.log(error);
					});
			},
			getsummaryfnc: function() {
				let _this = this;
				_this.summarycontent='';
				// _this.isloadingsum=true;
				fetch(
					(process.env.NODE_ENV === 'development' ? '/proxyaiapi/' : window.SITE_CONFIG.aiReadUrl)+'ReadSummary', 
					{
						method: 'POST',
						credentials: 'include',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({
							titleId: _this.articleid,
						})
					})
					.then(response => {
						const reader = response.body.getReader();
						const decoder = new TextDecoder();
						let isreturn =false;
						_this.isloadingsum=false;
						return reader.read().then(function processResult(result) {
						// debugger
							if (result.done) {
								isreturn =true;
							}
				
							const chunk = decoder.decode(result.value, {
								stream: true
							});
				
							console.log(chunk)
							
							_this.markdownTxt += chunk;
							if(_this.markdownTxt.indexOf('```')>-1){
								_this.markdownTxt=_this.markdownTxt.replace('```','');
							}
							if(_this.markdownTxt.indexOf('markdown')>-1){
								_this.markdownTxt=_this.markdownTxt.replace('markdown','');
							}
							_this.summarycontent = marked(_this.markdownTxt);
							
							if(isreturn){
								if(_this.summarycontent==''){
									_this.summarycontent='尊敬的用户您好，此文章暂时无法生成简读，让我们换一篇试试吧';
								}
								return;
							}
							return reader.read().then(processResult);
						});
					})
					.catch(error => {
						_this.isloadingsum=false;
						console.log(error);
					});
				
			},
			defaultQuestion:function(){
				let quesList=[
					'请简述文章主要内容',
					'请详细描述文章主旨',
					'请总结文章大纲脉络',
				];
				for(var i=0;i<quesList.length;i++){
					this.dialogueData.push({
						type:2,
						content:quesList[i]
					});
				}
			},
			clickQuestion:function(content){
				if(this.isdisableinput){
					return false;
				}
				this.aiask=content;
				this.askfnc(content);
			},
			askfnc:function(){
				let thisques=this.aiask;
				this.aiask='';
				this.dialogueData.push({
					type:0,
					content:thisques
				});
				this.dialogueData.push({
					type:1,
					content:'',
				});
				let _this=this;
				_this.$nextTick(function () {
					var tempdivhistory = document.getElementById('dialogue_history');
					tempdivhistory.scrollTop = tempdivhistory.scrollHeight;
				})
				_this.isloadingdialogue=true;
				_this.isdisableinput=true;
				fetch(
					(process.env.NODE_ENV === 'development' ? '/proxyaiapi/' : window.SITE_CONFIG.aiReadUrl)+'Dialogue', 
					{
						method: 'POST',
						credentials: 'include',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({
							titleId: _this.articleid,
							question: thisques,
							chatId: _this.usercode,
							// quote: 1,
						})
					})
					.then(response => {
						const reader = response.body.getReader();
						const decoder = new TextDecoder();
						let isreturn =false;
						_this.isloadingdialogue=false;
						let originTxt='';
						return reader.read().then(function processResult(result) {
						// debugger
							if (result.done) {
								isreturn =true;
							}
				
							const chunk = decoder.decode(result.value, {
								stream: true
							});
				
							console.log(chunk)
							
							// let originTxt=chunk;
							originTxt+=chunk;
							
							// //引用过滤
							// var tempmatch=originTxt.match(/@\[.*?\]@/g);
							// if(tempmatch){
							// 	// debugger
							// 	for(var i=0;i<tempmatch.length;i++){
							// 		_this.sourceList.push(tempmatch[i].replace('@[','').replace(']@','').replace(resultDetailData.articleTitle,''));
							// 		originTxt = originTxt.replace(tempmatch[i],'<a class="linktips" title="'+(tempmatch[i].replace('@[','').replace(']@','').replace(resultDetailData.articleTitle,''))+'">'+(_this.sourceList.length)+'</a>');
							// 	}
							// }
							
							// _this.dialogueData[_this.dialogueData.length-1].content+=originTxt.replace(/[\r|\n|\t]/g, "<br>");
							_this.dialogueData[_this.dialogueData.length-1].content=marked(originTxt);
							
							_this.$nextTick(function () {
								var tempdivhistory = document.getElementById('dialogue_history');
								tempdivhistory.scrollTop = tempdivhistory.scrollHeight;
							})
							
							if(isreturn){
								_this.isdisableinput=false;
								if(_this.dialogueData[_this.dialogueData.length-1].content==''){
									_this.dialogueData[_this.dialogueData.length-1].content='尊敬的用户您好，让我们换个话题再聊聊吧';
								}
								return;
							}
							return reader.read().then(processResult);
						});
					})
					.catch(error => {
						_this.isloadingdialogue=false;
						_this.isdisableinput=false;
						console.log(error);
					});
			},
		}
	}
</script>

<style>

</style>
